<template>
  <div class="wrapper p-4 w-100 h-100 d-flex align-items-center justify-content-center">
    <div class="survey_completed">
      <div class="survey_promotions" v-if="show_promotions">
        <div class="header">
          <figure v-html="survey.svg_logo"></figure>
          <div class="ue">
            <p>Research conducted by</p>
            <UELogo />
          </div>
        </div>
        <div class="completed_text">
          <p>Hi {{ recipient.first_name }},</p>
          <br />
          <div v-html="survey.completed_text"></div>
        </div>
        <div class="promotions">
          <div class="promotion" v-for="promotion in survey.survey_promotions" :key="promotion.id">
            <p v-html="promotion.caption"></p>
            <a
              :href="`/survey_promotions/${promotion.id}`"
              target="_blank"
              :title="promotion.button_text"
            >
              <figure v-html="promotion.button_svg"></figure>
            </a>
            <b-button
              size="sm"
              variant="primary"
              :style="`background-color: ${promotion.color}`"
              :href="`/survey_promotions/${promotion.id}`"
              target="_blank"
            >
              {{ promotion.button_text }}
            </b-button>
          </div>
        </div>
        <div class="greeting">
          <p v-html="survey.completed_text2" v-if="survey.completed_text2 != ''"></p>
          <p v-else>We really appreciate you helping to spread the word.</p>
          <br />
          <br />
          Thanks!<br />
          {{ survey.from_first_name }} {{ survey.from_last_name }}<br />
          {{ survey.from_title }}<br />
          <br />
          <p class="small">
            This survey was conducted by UserEvidence. UserEvidence is not affiliated with any of
            the companies being featured here. All trademarks and copyrights are the property of
            their respective owners.
          </p>
        </div>
        <div class="footer">
          <a href="https://www.userevidence.com/" target="_blank" title="Visit UserEvidence.com">
            <UELogo />
          </a>
          <ul>
            <li>
              <a
                href="https://www.userevidence.com/privacy"
                target="_blank"
                title="UserEvidence Privacy Policy"
              >
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="basic_completed" v-else>
        <h1>Survey Submitted</h1>
        <SurveyCompletedIcon class="mt-3" />
        <div class="mb-5">
          Thank you for taking the time to complete this survey. We will follow up with you
          accordingly based on your responses. Have a great day!
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import SurveyCompletedIcon from '@app/graphics/SurveyCompletedIcon.vue'
import UELogo from '@app/graphics/UELogo.vue'

export default {
  components: { SurveyCompletedIcon, UELogo },
  props: {
    survey: {
      type: Object,
      required: true,
    },
    recipient: {
      type: Object,
      required: true,
    },
  },
  computed: {
    show_promotions() {
      return (
        (this.recipient.nps_score >= this.survey.promotion_nps_threshold ||
          this.survey.always_show_promotions) &&
        this.survey.survey_promotions.length > 0
      )
    },
  },
}
</script>
<style lang="sass" scoped>

.basic_completed
  text-align: center
  max-width: 512px
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  svg
    margin-bottom: 20px

.survey_completed
  max-width: 760px
  padding: 32px
.survey_promotions
  .header
    display: flex
    justify-content: space-between
    align-items: center
    width: 100%
    margin-bottom: 36px
    figure
      width: 261px
    .ue
      display: flex
      align-items: center
      p
        font-size: 12px
        font-weight: 400
        color: hsl(200, 8%, 32%)
        margin: 0 8px 0 0
      svg
        width: 120px
  h1
    margin: 0 auto 24px
.completed_text
  margin-bottom: 36px
  ::v-deep div
    div
      strong
        color: hsl(200, 8%, 8%)
        font-weight: 800
.promotions
  display: flex
  justify-content: space-between
  flex-wrap: wrap
  p
    margin-bottom: 24px
.promotion
  border: 1px solid hsl(200, 24%, 88%)
  padding: 24px
  border-radius: 24px
  display: flex
  flex-direction: column
  align-items: center
  width: 47%
  margin-bottom: 36px
  .btn
    color: white
  p
    display: block
    margin-left: auto
    margin-right: auto
    // min-height: 90px
    ::v-deep strong
      color: hsl(200, 8%, 8%)
      font-weight: 800

.footer
  display: inline-flex
  justify-content: space-between
  align-items: center
  width: 100%
  max-width: 784px
  margin: 0
  padding: 32px 0
  font-weight: 400
  font-size: 12px
  font-weight: 400
  color: hsl(200, 8%, 32%)
  svg
    width: 80px
    height: 16px
    padding: 0
    margin: 0
  ul, li
    list-style: none
  ul
    margin: 0 !important
    padding: 0 !important
  li
    font-size: 10px
    font-weight: 500
    width: inherit
    a
      color: hsl(200, 8%, 8%) !important
      &:hover, &:focus, &:active
        color: var(--uePurple) !important
p.small
  margin: 24px auto 0
  font-size: 12px
  line-height: 16px
  color: hsl(200, 16%, 44%)
  a
    font-weight: 800
    color: hsl(200, 8%, 8%)
    text-decoration: underline

@media screen and (max-width: 576px)
  .promotions
    flex-direction: column
  .promotion
    width: 100%
    margin-bottom: 24px

  .survey_promotions .header
    display: block
    .ue
      display: block
</style>
